import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { IDeviceStateControllerReturn } from "../../../services/devicestate/DeviceStateController";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  isAutoPlay?: boolean;
  //isMobile?: boolean;
  //isLandscape?: boolean;
}

interface ISetContentAndShow {
  src: string;
  videoSizeRatio: number;
}

export interface IModalVideoControllerReturn {
  //states
  show: boolean, setShow: Dispatch<SetStateAction<boolean>>;
  src: string | Nude; //setText: Dispatch<SetStateAction<string | Nude>>;
  isMobile: boolean | undefined;
  isLandscape: boolean | undefined;
  isAutoPlay: boolean | undefined;
  videoSizeRatio: number;
  width: number
  //functions
  setContentAndShow: (props: ISetContentAndShow) => void;
  stopAndClose(): void;
}


export const ModalVideoController = (props: IProps): IModalVideoControllerReturn => {

  const tag = "ModalVideoController"
  //console.log(tag + "START")


  //#region states
  // const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);
  // useEffect(() => {
  //   setIsMobile(props.dsc.deviceDynamicState,isMobile)
  //   //const isMobile: boolean = props.dsc.deviceStateService.isMobileDevice()
  //  }, [props.dsc.deviceDynamicState.isMobile]);
  //useEffect(() => { setIsMobile(props.dsc.deviceStateService.isMobileDevice()) }, [props.isMobile]);
  // const [isLandscape, setIsLandscape] = useState<boolean | undefined>(undefined);
  // useEffect(() => { setIsLandscape(props.isLandscape) }, [props.isLandscape]);
  
  const [video, setVideo] = useState<HTMLVideoElement | null>(null);
  const [show, setShow] = useState<boolean>(false);
  const [src, setSrc] = useState<string | Nude>(undefined);
  //#endregion

  const [width, setWidth] = useState<number>(100);

  useEffect(() => {   
    setVideoWidth()
  },[props.dsc.eDeviceScreenState] )

  useEffect(() => {   
    setVideoWidth()
  },[props.dsc.isLandscape] )

  function setVideoWidth() {
    const sh = props.dsc.screenHeight();
    let w = props.dsc.isMobile ? videoSizeRatio * sh : sh;
    w = (!props.dsc.isLandscape)?props.dsc.screenWidth():w
    setWidth(w);
  }
   
  const [videoSizeRatio, setVideoSizeRatio] = useState<number>(1);
    useEffect(() => {   
    setVideoWidth()
  },[videoSizeRatio] )

  function setContentAndShow(propsC: ISetContentAndShow) {
    setSrc(propsC.src);
    setVideoSizeRatio(propsC.videoSizeRatio?propsC.videoSizeRatio:1) 
    setShow(true);
  }

  function stopAndClose() {
    if (video != null) { video.pause(); video.currentTime = 0; setVideo(null); }
    setShow(false)
  }

  const isAutoPlay: boolean | undefined = props.isAutoPlay;
  const isMobile: boolean = props.dsc.isMobile
  const isLandscape: boolean = props.dsc.isLandscape

  return {
    //states
    show, setShow,
    src,
    isMobile,
    isLandscape,
    isAutoPlay,
    videoSizeRatio,
    width,
    //functions
    setContentAndShow,
    stopAndClose
  }
}